import { render, staticRenderFns } from "./VerifyGoodsInOutResult.vue?vue&type=template&id=72d467b8&scoped=true&"
import script from "./VerifyGoodsInOutResult.vue?vue&type=script&lang=js&"
export * from "./VerifyGoodsInOutResult.vue?vue&type=script&lang=js&"
import style0 from "./VerifyGoodsInOutResult.vue?vue&type=style&index=0&id=72d467b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d467b8",
  null
  
)

export default component.exports